import {Table} from 'antd';
import {useEffect, useState} from 'react';
import {getAllReturns} from "../../api/Api";
import {fixedToDisplayUnit} from "../../util/unitutils";

export const ExistingReturn = ({refresh, onRefresh, onApiFail, props}) => {
    const [returns, setReturns] = useState([]);

    useEffect(() => {
        getAllReturns().then(result => {
            setReturns(result.map(r => {
                return {...r, key: r.id}
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);

    const columns = [
        {
            title: 'Invoice',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber'
        },
        {
            title: 'Processed by',
            dataIndex: 'username',
            key: 'username'
        },
        {
            title: 'Item',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                return displayQuantity;
            }
        },
        {
            title: 'Amount',
            dataIndex: 'refundAmount',
            key: 'refundAmount',
            render: (val) => `$ ${val}`
        }
    ]

    return <Table columns={columns} dataSource={returns} />
}